import React, { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { red } from '@mui/material/colors';

import { MonitoringCommandeAvoir } from 'types/monitoringAvoir';
import JsonViewerDialog from 'components/Shared/JsonViewerDialog/JsonViewerDialog';
import GeswebLink from 'components/Shared/GeswebLink';

const SEUIL_MS = 5 * 60 * 1000; // 5 minutes

const formatDate = (iso: string | null): string => {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString('fr-FR');
};

const origineLibelle = (origine: number): string => (origine === 1 ? 'BONFOUPHY' : 'BONWEB');

// Rouge si : latence DateIntegration → DateTraitementAvoir > 5 min,
// OU en souffrance (non traité depuis plus de 5 min).
const estEnAlerte = (c: MonitoringCommandeAvoir): boolean => {
    const integration = new Date(c.dateIntegration).getTime();
    if (c.dateTraitementAvoir) {
        return new Date(c.dateTraitementAvoir).getTime() - integration > SEUIL_MS;
    }
    return Date.now() - integration > SEUIL_MS;
};

// Ligne du tableau des commandes rattachées (avec dialog JSON dédié).
function MonitoringCommandeRow({ commande }: { commande: MonitoringCommandeAvoir }) {
    const [jsonOpen, setJsonOpen] = useState(false);
    const alerte = estEnAlerte(commande);

    return (
        <TableRow hover sx={{ height: 53 }}>
            <TableCell>
                <Link href={`/reclamations/${commande.reclamationId}`} target="_blank" rel="noopener noreferrer">
                    {commande.reclamationId}
                </Link>
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {commande.cle
                    ? <GeswebLink mode="button" label={commande.numeroPiece} structure="commande" cle={commande.cle} />
                    : commande.numeroPiece}
            </TableCell>
            <TableCell>{origineLibelle(commande.origineSaisie)}</TableCell>
            <TableCell>
                {commande.depot
                    ? (
                        <Tooltip title={commande.depot.nom ?? ''}>
                            <span>{commande.depot.code}</span>
                        </Tooltip>
                    )
                    : '—'}
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(commande.dateIntegration)}</TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap', ...(alerte ? { color: red[700], fontWeight: 'bold' } : {}) }}>
                {commande.dateTraitementAvoir ? formatDate(commande.dateTraitementAvoir) : 'Non traité'}
            </TableCell>
            <TableCell align="right">
                <Tooltip title="Voir le message JSON">
                    <span>
                        <IconButton size="small" onClick={() => setJsonOpen(true)} disabled={!commande.messageJson}>
                            <DataObjectIcon fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
                <JsonViewerDialog
                    open={jsonOpen}
                    onClose={() => setJsonOpen(false)}
                    title={`Message JSON — ${commande.numeroPiece}`}
                    jsonEntries={[{ label: commande.cle, value: commande.messageJson, dateIntegration: commande.dateIntegration }]}
                />
            </TableCell>
        </TableRow>
    );
}

export default MonitoringCommandeRow;
